import { isIEorEdge, isIOS } from 'utils/DOM';
import { isValid as isDateValid } from 'date-fns';

export const convertToUTC = date => {
  if (date instanceof Date) {
    return new Date(
      Date.UTC(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds()
      )
    );
  }
};

export const clearTime = date => date.setHours(0, 0, 0, 0);

export const formatTime = (time, intl, hour12, isHour12Disabled) => {
  if (time) {
    let timeFormatted = intl
      .formatTime(time, hour12 ? { hour12: true } : '')
      .replace(isHour12Disabled ? /am|pm|a\..?m\.|p\..?m\.|\s/gi : '', '')
      .replace(/\s/gi, '')
      .replace(/(a.m.|am|a. m.)/gi, ' AM')
      .replace(/(p.m.|pm|p. m.)/gi, ' PM');

    if (intl.locale === 'fr-CA' && (isIEorEdge || isIOS)) {
      timeFormatted = timeFormatted
        .replace(':', 'h')
        .split('.')
        .join('');
    }
    return timeFormatted;
  }
};

export const isToday = date => {
  if (!date) {
    return false;
  }
  const today = new Date();
  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  );
};

export const isValidRegistrationDate = regDate => {
  if (regDate) {
    const registrationDate = new Date(regDate);
    return registrationDate instanceof Date && isDateValid(registrationDate);
  }
  return false;
};

export const formatIOSDate = date => {
  const formatDateParts = date.split(/[^0-9]/);
  return new Date(
    formatDateParts[0],
    formatDateParts[1] - 1,
    formatDateParts[2],
    formatDateParts[3],
    formatDateParts[4],
    formatDateParts[5]
  );
};



// WEBPACK FOOTER //
// ./src/utils/date.js